import { useEffect, useRef, useState } from 'react';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import dayjs from 'dayjs';
import { Button, Popover, Space, Switch, Tooltip } from 'antd';
import antdMessage from '../../../utilsTsx/components/system/antdMessage';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebComponent = (props: any) => {
    const title = '会员积分明细';
    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;
    /** 当前打开的 Popover ID */
    const [activePopoverId, setActivePopoverId] = useState<string | null>(null);
    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [fetchData, setFetchData] = useState<any>();

    useEffect(() => {
        if (ref.current) {
            setDefaultService(ref.current.defaultService);
            setFetchData(() => ref.current.fetchData);
        }
    }, []);

    //表头
    const columnsHead = [
        {
            title: '方案',
            dataIndex: 'membershipPointsPlans',
            render: (val: any) => val?.planName
        },
        {
            title: '类型',
            dataIndex: 'membershipTransactionType',
            render: (val: any, record: any) =>
                < Tooltip placement="topLeft" title={`商户：${record?.merchantId}；
            商户单类型：${record?.merchantOrderTypeId}；
            商户单号：${record?.merchantOrderId}`} > {
                        val?.name
                    }</Tooltip>
        },
        {
            title: '店铺',
            dataIndex: 'shop',
            render: (text: any) => text?.shopName
        },
        {
            title: '交易日期',
            dataIndex: 'sysDate',
            render: (text: any) => dayjs(text.createdAt).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '积分变动',
            dataIndex: 'pointsChange',
            render: (val: number) => <text style={{ color: 'yellow' }}>{val}</text>
        },
        {
            title: '现积分',
            dataIndex: 'currentPoints'
        },
        {
            title: '兑换金额',
            dataIndex: 'pointsRedeemAmount',
            render: (val: number) => <text style={{ color: 'red' }}>{val !== 0 ? val : ''}</text>
        },
        {
            title: '成功',
            dataIndex: 'isTransactionSuccessful',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '成功日期',
            dataIndex: 'successfulDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '撤销',
            dataIndex: 'isTransactionVoid',
            render: (text: any, record: any) => (
                <Switch checkedChildren="是" unCheckedChildren="否"
                    checked={text} key={record.id}
                />
            )
        },
        {
            title: '撤销',
            dataIndex: 'membershipTransactionVoidType',
            render: (val: any) => val?.name
        },
        {
            title: '撤销日期',
            dataIndex: 'transactionVoidDate',
            render: (text: any) => dayjs(text).format('YYYY-MM-DD HH:mm:ss')
        },
        {
            title: '',
            dataIndex: 'id',
            render: (id: string, record: any) => (
                ((record.membershipTransactionTypeId === 1 || record.membershipTransactionTypeId === -1) &&
                    record.isTransactionVoid === false && !record.membershipTransactionDetails) ?
                    <Popover
                        title="是否撤销？"
                        trigger="click"
                        content={(<Space>
                            <Button onClick={() => setActivePopoverId(null)}>否</Button>
                            <Button type='primary' onClick={() => {
                                fetchApi.PUT(defaultService,
                                    {
                                        body: {
                                            apiId: 'membership',
                                            apiExtend: 'pointsTransactionVoid',
                                            apiData: {
                                                originalMembershipPointsDetailsId: id
                                            }
                                        }
                                    }).then(res => {
                                        if (res?.success === true) {
                                            antdMessage('success', '执行积分撤销成功');
                                            fetchData();
                                        } else {
                                            antdMessage('error', res?.message);
                                        }
                                    });
                                setActivePopoverId(null);
                            }}>是</Button>
                        </Space>)}
                        open={activePopoverId === id}
                        onOpenChange={(visible) => {
                            setActivePopoverId(visible ? id : null);
                        }}
                    >
                        <Button type="dashed" >撤销</Button>
                    </Popover> : null)
        }
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: title,
        apiId: 'membershipPointsDetails',
        columns,
        serviceId: 'business',
        displayOptions: {
            showAdd: false,
            showEdit: false
        },
        expandableOptions: {
            parentKey: 'originalMembershipPointsDetailsId',
            subColumns: columns,
            subDataName: 'children',
            isSameMainDisplayOptions: true,
            isTree: true
        },
        sendPageData: data
    };

    return (
        <>
            <AntDraggableModal
                title={title}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={closeModal}
                closable={false}
                maskClosable={false}
                width={1500} >
                <WebUniversal {...extendProps} ref={ref} />
            </AntDraggableModal>
        </>
    )
}

export default WebComponent;
